<template>
  <div class="prodetail-checkout">
    <form action id="checkoutform" class="form-default">
      <div class="checkout-info">
        <div v-click-outside="clickOutSite">
          <div class="form-group">
            <div
              class="select-custom"
              :class="{
                active: isOpenDopdown === 'type'
              }"
            >
              <a class="current" @click.prevent="setIsOpenDropdown('type')">
                {{
                  type && type.title
                    ? type.title.rendered
                    : $t("app.Please select")
                }}
              </a>
              <slide-up-down
                :active="isOpenDopdown === 'type'"
                tag="ul"
                :duration="100"
              >
                <li v-for="(item, index) in typesOptions" :key="index">
                  <a @click.prevent="onChangeFilter('type', item)">{{
                    item.title.rendered
                  }}</a>
                </li>
              </slide-up-down>
            </div>
          </div>
          <div class="form-group">
            <div
              class="select-custom"
              :class="{
                active: isOpenDopdown === 'categorie'
              }"
            >
              <a
                href
                class="current"
                @click.prevent="setIsOpenDropdown('categorie')"
              >
                {{
                  categorie.title
                    ? categorie.title.rendered
                    : $t("app.Toutes catégories")
                }}
              </a>
              <slide-up-down
                :active="isOpenDopdown === 'categorie'"
                tag="ul"
                :duration="100"
              >
                <li v-for="(item, index) in categoriesOptions" :key="index">
                  <a @click.prevent="onChangeFilter('categorie', item)">{{
                    item.title.rendered
                  }}</a>
                </li>
              </slide-up-down>
            </div>
          </div>
          <div class="form-group">
            <div class="select-custom date-group">
              <a href class="current" @click.prevent>
                {{ $t("app.Du") }}
                <date-picker
                  v-model="dateFrom"
                  format="DD/MM/YYYY"
                  type="date"
                  class="datepicker"
                  placeholder="dd/mm/Y"
                  :disabled-date="disabledDateFrom"
                  @open="onOpenDatePicker('dateFrom')"
                  @change="onChangeFromDatePicker"
                ></date-picker>
              </a>
            </div>
          </div>
          <div class="form-group">
            <div class="select-custom date-group">
              <a href class="current" @click.prevent>
                {{ $t("app.au") }}
                <date-picker
                  v-model="dateTo"
                  format="DD/MM/YYYY"
                  type="date"
                  class="datepicker"
                  placeholder="dd/mm/Y"
                  :disabled-date="notBeforeDate"
                  @open="onOpenDatePicker('dateTo')"
                  @change="onChangeToDatePicker"
                ></date-picker>
              </a>
            </div>
          </div>
          <div class="form-group">
            <div
              class="select-custom field-people"
              :class="{
                active: isOpenDopdown === 'adultes'
              }"
            >
              <a
                href
                class="current"
                @click.prevent="setIsOpenDropdown('adultes')"
              >
                {{ totalPersons > 0 ? totalPersons : $t("app.adultes") }}
              </a>
              <slide-up-down
                :active="isOpenDopdown === 'adultes'"
                tag="ul"
                :duration="100"
              >
                <li
                  class="quantity-item"
                  v-for="(item, index) in adultsConfig"
                  :key="index"
                >
                  <b>{{ item.name }}</b>
                  <div class="quantity-group quantity-adulte">
                    <a
                      href
                      class="minus"
                      @click.prevent="onMinus(item)"
                      v-bind:class="{
                        isDisabled: item.quantity <= 0
                      }"
                      >-</a
                    >
                    <input
                      type="number"
                      min="0"
                      disabled
                      v-model="item.quantity"
                    />
                    <a href class="plus" @click.prevent="onPlus(item)">+</a>
                  </div>
                </li>
                <li>
                  <a href class="btn apply" @click.prevent="onApplyAdults()">{{
                    $t("app.Ajouter")
                  }}</a>
                </li>
              </slide-up-down>
            </div>
          </div>
        </div>

        <div class="services-more">
          <h3 class="font-bai text-uppercase">{{ $t("app.Services") }} :</h3>
          <ul class="services-list">
            <li v-for="(item, index) in services" :key="index">
              <label class="checkbox-custom font-bai active checkbox-show">
                <input type="checkbox" name id />
                <div class="des">
                  <h4>{{ item.name }}</h4>
                  <p>
                    <i v-html="item.description"></i>
                  </p>
                </div>
              </label>
            </li>
          </ul>
        </div>
        <div class="inclus-more" v-if="includeServices.length">
          <h3 class="font-bai text-uppercase">{{ $t("app.Inclus") }} :</h3>
          <ul class="list-inline font-bai font-bold">
            <li
              class="item-inline"
              v-for="(item, index) in includeServices"
              :key="index"
            >
              <img :src="item.icon" alt v-if="item.icon" />
              {{ item.name }}
            </li>
          </ul>
        </div>
      </div>
      <div class="text-center checkout-price font-bai">
        <p>
          <b>
            <i>{{ getRoomBookTime() }}</i>
          </b>
        </p>
        <div class="price">
          {{ $t("app.à partir de") }}
          <div class="price-text">
            <b class="font-balo">{{ getPrice() }} {{ currency.symbol }}</b>
            <span>{{ $t("app.Taxe de séjour incluse") }}</span>
          </div>
        </div>
      </div>
      <a @click.prevent="onAddToCart" class="btn font-balo font-bold">
        {{ $t("app.réserver") }}
        <span>{{ $t("app.(en 2 min Chrono)") }}</span>
      </a>
    </form>
  </div>
</template>

<script>
import moment from "moment";
import { mapState, mapActions, mapMutations } from "vuex";
import DatePicker from "vue2-datepicker";
import {
  get,
  first,
  filter,
  find,
  map,
  forEach,
  includes,
  sumBy
} from "lodash";
import ClickOutside from "vue-click-outside";
import { adults } from "@/helper/config";
import {
  numberOfNightsBetweenDates,
  checkIsValidDatePayment,
  formatBookDate
} from "@/helper/calculateDays";

const today = new Date();
export default {
  name: "RoomDetailCheckout",
  components: { DatePicker },
  props: ["room"],
  data() {
    const adultsConfig = adults.filter(item => item.key !== "animal");

    return {
      isOpenDopdown: null,
      dateFrom: null,
      dateTo: null,
      type: {},
      categorie: {},
      adult: null,
      child: null,
      child1: null,
      animal: null,
      adultsConfig: adultsConfig,
      includeServices: [],
      services: [],
      typesOptions: [],
      categoriesOptions: [],
      totalPersons: 0
    };
  },
  mounted() {
    this.includeServices = filter(
      get(this.room, "camping.services", []),
      item => item.inclus
    );
    this.totalPersons = this.getTotalPersons();
    this.services = filter(
      get(this.room, "info.services", []),
      item => !item.inclus
    );
    const camping = find(
      this.campingClubs,
      item => item.id === this.filter.camping
    );
    this.camping = camping;
    this.getTypesByCamping(camping);
    const type = find(this.types, item => item.id === this.filter.type);
    this.type = type;
    this.getCategoriesByCampingAndType();
    const categorie = find(
      this.categoriesOptions,
      item => item.id === this.filter.categorie
    );
    this.categorie = categorie || {};
    this.dateFrom = new Date(this.filter.dateFrom);
    this.dateTo = new Date(this.filter.dateTo);

    this.adult = this.filter.adult;
    this.child = this.filter.child;
    this.animal = this.filter.animal;
    this.dateFrom = new Date(this.filter.dateFrom);
    this.dateTo = new Date(this.filter.dateTo);
    if (get(type, "title.rendered") === "Emplacement nu") {
      this.adultsConfig = adults.map(item => ({
        ...item,
        quantity: get(this.filter, item.key) || 0
      }));
    } else {
      this.adultsConfig = this.adultsConfig.map(item => {
        const qty = get(this.filter, item.key);
        return {
          ...item,
          quantity: qty
        };
      });
    }
    let dataReferences = this.filter;
    this.onGetRefences(dataReferences);
  },
  computed: {
    ...mapState({
      campingClubs: state => get(state, "campingClubs.list", []),
      categories: state => get(state, "categories.list", []),
      types: state => get(state, "types.list", []),
      // references: state => get(state, "hotels.references.references", []),
      filter: state => get(state, "hotels.filter", {}),
      currency: state => get(state, "app.currency")
    })
  },
  methods: {
    ...mapActions("cart", ["addToCart", "setStep"]),
    ...mapActions("hotels", ["getAvailability", "getReferences"]),
    ...mapMutations("hotels", ["setFilter"]),
    getRoomBookTime() {
      const dateFrom = moment(this.filter.dateFrom).format("ddd DD");
      const dateTo = moment(this.filter.dateTo).format("ddd DD");
      const totalDate = numberOfNightsBetweenDates(
        moment(this.filter.dateFrom),
        moment(this.filter.dateTo)
      );
      if (totalDate > 1) {
        return `${this.$i18n.t("app.Du")} ${dateFrom} ${this.$i18n.t(
          "app.au"
        )} ${dateTo}. (${totalDate} ${this.$i18n.t("app.nuits")})`;
      } else {
        return `${this.$i18n.t("app.Du")} ${dateFrom} ${this.$i18n.t(
          "app.au"
        )} ${dateTo}. (${totalDate} ${this.$i18n.t("app.nuit")})`;
      }
    },
    getPrice() {
      const roomOccupancyAvailabilities = first(
        this.room.RoomOccupancyAvailabilities
      );
      return get(
        roomOccupancyAvailabilities,
        `Pricing.0.Price.TotalAmount.${this.currency.code}.GrossValue`
      );
    },
    disabledDateFrom(date) {
      if (!this.dateTo) {
        return date <= today;
      }
      return date <= today || date >= this.dateTo;
    },
    notBeforeDate(date) {
      return date <= this.dateFrom;
    },
    setIsOpenDropdown(key) {
      this.isOpenDopdown = this.isOpenDopdown !== key ? key : null;
    },
    clickOutSite() {
      this.isOpenDopdown = null;
    },
    onOpenDatePicker(type) {
      this.isOpenDopdown = null;
      if (type === "dateFrom") {
        this.dateTo = null;
      }
    },
    onChangeFromDatePicker(date) {
      this.onChangeFilter("dateFrom", date);
    },
    onChangeToDatePicker(date) {
      this.onChangeFilter("dateTo", date);
    },
    onChangeFilter(key, data) {
      this[key] = data;
      if (key === "type") {
        this.getCategoriesByCampingAndType();
      }
      if (key === "type" || key === "categorie") {
        this.onSubmitFilter();
      }
      if (key === "dateFrom" || key === "dateTo") {
        let dataReferences = this.filter;
        dataReferences = {
          ...dataReferences,
          dateFrom: this.dateFrom,
          dateTo: this.dateTo
        };
        this.setFilter(dataReferences);
        this.onGetRefences(dataReferences);
      }
    },
    getTypesByCamping(camping) {
      const types = filter(this.types, item => {
        if (Array.isArray(get(item, "acf.types_camping"))) {
          return includes(get(item, "acf.types_camping", []), camping.id);
        }
        return get(item, "acf.types_camping") === camping.id;
      });
      this.typesOptions = types;
    },
    getCategoriesByCampingAndType() {
      if (!this.type) this.categoriesOptions = [];

      const categories = filter(this.categories, item => {
        if (
          Array.isArray(get(item, "acf.cacamping_club")) &&
          Array.isArray(get(item, "acf.cate_types"))
        ) {
          return (
            includes(
              get(item, "acf.cacamping_club", []),
              get(this, "filter.camping")
            ) && includes(get(item, "acf.cate_types", []), get(this, "type.id"))
          );
        }
      });
      this.categoriesOptions = [
        {
          id: "",
          title: {
            rendered: this.$i18n.t("app.Toutes catégories")
          }
        },
        ...categories
      ];
    },
    onAddToCart() {
      if (this.totalPersons === 0) {
        this.$bvToast.toast(
          this.$i18n.t("app.Please correct your participants"),
          {
            title: this.$i18n.t("app.Error"),
            variant: "danger",
            solid: true
          }
        );
        return;
      }
      if (!checkIsValidDatePayment(this.filter.dateFrom, this.filter.dateTo)) {
        this.$bvToast.toast(this.$i18n.t("app.Please correct your dates"), {
          title: this.$i18n.t("app.Error"),
          variant: "danger",
          solid: true
        });
        return;
      }
      this.addToCart({
        room: this.room,
        info: {
          adult: this.filter.adult,
          child: this.filter.child,
          child1: this.filter.child1,
          animal: this.filter.animal,
          dateFrom: this.filter.dateFrom,
          dateTo: this.filter.dateTo
        }
      });
      this.setStep("step1");
      this.$router.push("/cart");
    },
    getTotalPersons() {
      const child = this.filter.child || 0;
      const child1 = this.filter.child1 || 0;
      const adult = this.filter.adult || 0;
      const totalPersons = child + child1 + adult;
      return totalPersons;
    },
    onSubmitFilter() {
      let dataReferences = {
        ...this.filter,
        type: get(this, "type.id"),
        categorie: get(this, "categorie.id")
      };
      this.setFilter(dataReferences);
      this.$router.push("/result");
    },
    onApplyAdults() {
      forEach(this.adultsConfig, item => {
        this[item.key] = item.quantity;
      });
      this.isOpenDopdown = null;
      let dataReferences = this.filter;
      dataReferences = {
        ...dataReferences,
        adult: this.adult,
        child: this.child || 0,
        child1: this.child1 || 0
      };
      if (this.animal !== 0) {
        dataReferences.animal = this.animal;
      }
      this.onGetRefences(dataReferences);
    },
    onGetRefences(dataReferences) {
      if (
        !dataReferences.dateFrom ||
        !dataReferences.dateTo ||
        dataReferences.adult <= 0
      ) {
        // this.$bvToast.toast("Please select date from, date to", {
        //   title: `Error`,
        //   variant: "danger",
        //   solid: true
        // });
        return;
      }
      dataReferences = {
        ...dataReferences,
        dateFrom: formatBookDate(dataReferences.dateFrom),
        dateTo: formatBookDate(dataReferences.dateTo)
      };
      this.getReferences(dataReferences).then(res => {
        const { references } = res;
        if (references) {
          let data = {
            StartUtc: formatBookDate(dataReferences.dateFrom),
            EndUtc: formatBookDate(dataReferences.dateTo),
            AdultCount: dataReferences.adult,
            ChildCount:
              Number(dataReferences.child) + Number(dataReferences.child1),
            CategoryIds: map(references, item => item.id)
          };
          if (dataReferences.voucher) {
            data.VoucherCode = dataReferences.voucher;
          }
          this.getAvailability(data)
            .then(() => {})
            .catch(e => {
              if (!get(e, "Message")) return;
              this.$bvToast.toast(get(e, "Message", ""), {
                title: `Error`,
                variant: "danger",
                solid: true
              });
              return;
            });
        }
      });
    },
    checkIsMaxNormalBedCount() {
      const normalBedCount = this.room.NormalBedCount;
      const totalPersons = sumBy(this.adultsConfig, item => {
        return get(item, "quantity");
      });
      return totalPersons >= normalBedCount;
    },
    onMinus(item) {
      if (item.quantity === 0) return;
      return item.quantity--;
    },
    onPlus(item) {
      if (this.checkIsMaxNormalBedCount()) return;
      return item.quantity++;
    }
  },

  directives: {
    ClickOutside
  },
  watch: {
    filter: function() {
      this.totalPersons = this.getTotalPersons();
    }
  }
};
</script>
